<template>
  <responsive-modal
    v-model="visible"
    size="lg"
    title="Integração Utmify"
    link="https://utmify.com.br"
    description="Conheça a Utmify"
  >
    <bp-select
      v-model="form.product_id"
      label="Produto"
      required
      placeholder="Selecionar produto"
      :disabled="!!form.id"
      :options="products.map(({ id, name }) => ({ id, name }))"
    />

    <bp-input
      class="mt-5"
      v-model="form.token"
      required
      label="Token"
      placeholder="Digite o token"
      :errors="errors.token"
    />

    <footer-actions
      class="mt-7"
      :loading="loading"
      :disabled="!isValid"
      @submit="submit"
      @cancel="visible = false"
    />
  </responsive-modal>
</template>
<script>
import { formFields } from "@/functions/helpers";
import { mapState } from "vuex";
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    integrationToEdit: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      ...formFields(["id", "product_id", "status", "token"]),
      loading: false,
      visible: false
    };
  },
  watch: {
    value(v) {
      this.visible = v;
    },
    visible(v) {
      this.$emit("input", v);
      if (!v) {
        this.clear();
      }
    },
    integrationToEdit(v) {
      this.form = {
        ...v
      };
    }
  },
  computed: {
    ...mapState("product", ["products"]),
    isValid() {
      return this.form.product_id && this.form.token;
    }
  },
  methods: {
    clear() {
      this.form = {};
      this.$emit("clear-edit");
    },
    onSubmit() {
      this.visible = false;
      this.$emit("refresh");
      this.clear();
    },
    submit() {
      this.loading = true;

      const data = {
        ...this.form
      };
      let action = "integration/postIntegration";

      if (this.integrationToEdit) {
        data.id = this.integrationToEdit.id;
        action = "integration/putIntegration";
      }

      this.$store
        .dispatch(action, data)
        .then(() => {
          this.onSubmit();
          this.$message.success("A integração foi salva!");
        })
        .catch(e =>
          this.handleErrors(
            e,
            "TRANSLATE_FIELD_INTEGRATION_MAP",
            "Erro ao salvar integração"
          )
        )
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
